const rule = {
    tagname: [{
        required: true,
        type: 'string',
        message: '请填写标签名称',
        trigger: 'blur'
    }],
    istype : [{
        required: true,
        type: 'array',
        message: '请选择所属模块',
        trigger: 'change'
    }],
    tagtype : [{
        required: true,
        type: 'string',
        message: '请选择所属分类',
        trigger: 'change'
    }],
};

export default rule;


// WEBPACK FOOTER //
// ./src/validateRule/company/tagList.js